import { render } from "./ImageResizeModal.vue?vue&type=template&id=3d3e89c0&scoped=true"
import script from "./ImageResizeModal.vue?vue&type=script&lang=js"
export * from "./ImageResizeModal.vue?vue&type=script&lang=js"

import "./ImageResizeModal.vue?vue&type=style&index=0&id=3d3e89c0&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d3e89c0"]])

export default __exports__